const title = 'TVFUNSTAR';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function getPageTitle(pageTitle) {
  return pageTitle || title;
}
